import React from 'react'

import * as css from './MantenedorHospedajes.css'
//Componentes
import { RowHospedajes } from './RowHospedajes.jsx'

export class TablaHospedajes extends React.Component{
    constructor(props){
        super(props)
        this.rows = []
    }
    focusRow(index, nombreElemento){
        let ultimoIndex = this.rows.length
        let elemento = nombreElemento
        if(index<0){
            // al seleccionar "antes de la primera", se seleciona el ultimo
            this.rows[ultimoIndex].focusElemento(elemento)
        }else if(index>=ultimoIndex){
            // al seleccionar "despues de la ultima", se selecciona el primero de la siguiente columna
            if(elemento==='inputColacion')
                elemento = 'inputViatico'
            else if(elemento==='inputViatico')
                elemento = 'inputMedioViatico'
            else if(elemento==='inputMedioViatico')
                elemento = 'inputIdComunaOrigen'
            else if(elemento==='inputIdComunaOrigen')
                elemento = 'inputIdComunaSecundaria'
            else if(elemento==='inputIdComunaSecundaria')
                elemento = 'inputColacion'
            this.rows[0].focusElemento(elemento)
        }else{
            // no es ni el ultimo, ni el primero
            this.rows[index].focusElemento(elemento)
        }
    }
    render() {
        let cantidadHospedajes = this.props.hospedajes.length
        return (
            <div>
                {cantidadHospedajes > 0?
                        <TablaHospedaje>
                            {_.range(0, cantidadHospedajes).map(index=>{
                                let hospedaje = this.props.hospedajes[index]
                                return <RowHospedajes
                                    key={index}
                                    index={index}
                                    ref={ref=>this.rows[index]=ref}
                                    focusRow={this.focusRow.bind(this)}
                                    hospedaje={hospedaje}
                                />
                            })}
                        </TablaHospedaje>
                    :
                        <label>Cargando hospedajes...</label>
                }
            </div>
        )
    }
}
let TablaHospedaje = ({children}) =>
    <div className="panel panel-default">
        <table className={"panel-body table table-bordered table-condensed table-striped "+css.tableFixed}>
            <colgroup>
                <col className={css.colIndex}/>
                <col className={css.colNombre}/>
                <col className={css.colCiudad}/>
                <col className={css.colPrioridad}/>
                <col className={css.colMailPrincipal}/>
                <col className={css.colTelefonoFijo}/>
                <col className={css.colCelular}/>
                <col className={css.colCelularWsp}/>
                <col className={css.colDireccion}/>
                <col className={css.colSingleConBano}/>
                <col className={css.colDobleConBano}/>
                <col className={css.colAcciones}/>
            </colgroup>
            <thead>
                <tr>
                    <th className={css.thIndex}>#</th>
                    <th className={css.thNombre}>Nombre</th>
                    <th className={css.thCiudad}>Ciudad</th>
                    <th className={css.thPrioridad}>Prioridad</th>
                    <th className={css.thMailPrincipal}>Mail Principal</th>
                    <th className={css.thTelefonoFijo}>Telefono Fijo</th>
                    <th className={css.thCelular}>Celular</th>
                    <th className={css.thCelularWsp}>Whatsapp</th>
                    <th className={css.thDireccion}>Dirección</th>
                    <th className={css.thSingleConBano}>Single</th>
                    <th className={css.thDobleConBano}>Doble</th>
                    <th className={css.thAcciones}/>
                </tr>
            </thead>
            <tbody>
                {children}
            </tbody>
        </table>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/proveedores/hospedajes/TablaHospedajes.jsx